/** Placeholders written in place of values the logger must not emit, and the log levels. */

/** Replaces the value of a key on the sensitive-key denylist. */
export const REDACTED_PLACEHOLDER = '[redacted]';

/** Replaces a fødselsnummer-shaped value found inside a string. */
export const REDACTED_NATIONAL_ID_PLACEHOLDER = '[redacted-fnr]';

/** Replaces a value nested deeper than the redaction depth cap. */
export const TRUNCATED_PLACEHOLDER = '[truncated]';

/** Replaces a value already visited on the current path. */
export const CIRCULAR_PLACEHOLDER = '[circular]';

/** Every log level, least severe first. */
export const LOG_LEVELS = ['debug', 'info', 'warn', 'error'] as const;

/** Replaces an error's `cause` that is not itself an error, such as a parsed response body. */
export const NON_ERROR_CAUSE_PLACEHOLDER = '[non-error cause]';
